export default __webpack_public_path__ + "static/96333-221f5076da2110e826d78aa9ddabb9ac.jpg";